var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box",class:{'wide-side-nav':_vm.$store.state.theme.wideSideNav}},[_c('toolbar'),_vm._v(" "),_c('side-nav'),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }